<template>
  <div>
	<v-system-bar
		window
		app
		height="50"
		:class="['grey--text text--darken-4', colors[messageList.type]]"
		v-if="unreadCount > 0 && (
			pathMessage === path || !messageList.page
		) && !hideMessage"
	>
	  <v-icon>{{ messageList.icon }}</v-icon>
	  <span id="alert-system-bar" v-html="messageList.message"></span>
	  <v-spacer></v-spacer>

	  	<v-checkbox v-model="removeMessage" color="primary" label="Não exibir essa mensagem novamente" class="hide-message"></v-checkbox>

	  	<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<ButtonsFab x-small icon="mdi-window-close" color="white" @click.stop="hideMessage = true" v-bind="attrs" v-on="on" />
			</template>
			<span>Fechar mensagem</span>
    	</v-tooltip>
	</v-system-bar>
  </div>
</template>

<script setup>

import { ref, onMounted, watch, computed } from 'vue';
import { useStore } from '@/composables/useStore.js';
import { useFilters } from '@/composables/useFilters'
import { useRoute } from '@/composables/useRoute'

const route = useRoute()

const path = computed(() => {
	return route.value.path
})

const { parseDate } = useFilters()

const store = useStore()
const ActionRequest = (action, params) => store.dispatch(action, params);

const messages = ref([]);
const hideMessage = ref(false);
const removeMessage = ref(false);

const colors = { 
	info: 'info lighten-2',
	warning: 'warning',
	error: 'error' 
};

const pathMessage = ref('')

//Identifica quantas mensagens não lidas
const getReadIds = () => {
  try {
	return JSON.parse(localStorage.getItem('alertReadIds')) || [];
  } catch (e) {
	return [];
  }
};

const unreadCount = ref(0);

// Função para alternar o status de leitura de uma mensagem após o clique no fechar
const toggleReadStatus = (id) => {
  const readIds = getReadIds();
  if (!readIds.includes(id)) {
	readIds.push(id);
	localStorage.setItem('alertReadIds', JSON.stringify(readIds));
	setMessagesList(messages.value);
	hideMessage.value = false;
  }
};

// Propriedade computada para obter a primeira mensagem não lida
const messageList = ref([]);

const getData = async () => {

	let today = new Date();
	today = parseDate(today.toISOString())

	const params = {
		find_columns: { active: 1 },
		filter_columns: [
			{ column: 'start_date', operator: 'less_equal', value: today },
			{ column: 'end_date', operator: 'greater_equal', value: today }
		]
	};

	await ActionRequest('systemAlertMessage/ActionGetSystemAlertMessages', params)
		.then(response => {
			setMessagesList(response.data);
		})
		.catch(error => {
			//
		});
}

const setMessagesList = (msg) => {

	if(!msg || msg.length === 0) {
		messageList.value = [];
		unreadCount.value = 0;
		messages.value = [];
		return;
	}

	const readIds = getReadIds();
	const unread = msg.filter(msg => !readIds.includes(msg.id));
	
	if(unread.length > 0) {
		messageList.value = unread[0]
		unreadCount.value = unread.length;
		messages.value = unread;

	} else {
		messageList.value = [];
		unreadCount.value = 0;
		messages.value = [];
	}
}

watch(
	() => store.state.auth.token, 
	() => {
		getData();
	}
)

watch(
	() => messageList.value.page,
	(val) => {
		if(val) {
			pathMessage.value = '/' + val;
		} else {
			pathMessage.value = '';
		}
	}
)

watch(removeMessage, (val) => {
	if (val) {
		toggleReadStatus(messageList.value.id);
	}
})

onMounted(() => {
	getData();
});

</script>

<style >

#alert-system-bar a, #alert-system-bara:visited {
	color: #212121 !important;
	caret-color: #212121 !important;
	font-weight: bold;
}

#alert-system-bar p {
	margin: 0;
	padding: 0;
}

.hide-message .v-label {
	font-size: 12px !important;
	margin-right: 14px !important;
}

</style>
